import React from 'react';
import FWListing from './Rpt_FeeWaiver_Listing';
import '../../../CommonCSS/SocietyCSS.css'

const RptFWListingApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Fee Waiver Listing</h5>
          </div>
        </div>
        <FWListing />
      </div>
    </div >
  );
};

export default RptFWListingApp;
